import React from "react";
import { useRequiredMsgs } from "../../store/requiredMsgs";
import { useStore } from "../../store/store";

const useBackplateSelector = () => {
  const addToQuote = useStore((state) => state.addToQuote);
  const pivotBackPlate = useStore((state) => state.quote.pivotBackPlate);
  const pivotBackPlateColor = useStore(
    (state) => state.quote.pivotBackPlateColor
  );

  const findRequired = useRequiredMsgs((state) => state.findRequired);
  const removeRequired = useRequiredMsgs((state) => state.removeRequired);

  const handleClick = (label: string) => {
    const checked = label === pivotBackPlate;

    if (checked) {
      addToQuote({ pivotBackPlate: "" });
    } else {
      if (findRequired("Back Plate")) removeRequired("Back Plate");
      addToQuote({ pivotBackPlate: label });
    }
  };

  const handleClickColor = (label: string) => {
    const checked = label === pivotBackPlateColor;

    if (checked) {
      addToQuote({ pivotBackPlateColor: "" });
    } else {
      if (findRequired("Back Plate Finish"))
        removeRequired("Back Plate Finish");
      addToQuote({ pivotBackPlateColor: label });
    }
  };

  return {
    handleClick,
    handleClickColor,
    pivotBackPlate,
    pivotBackPlateColor,
  };
};

export default useBackplateSelector;
